// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__gnw+f"};